import {useLaunchParams} from "@telegram-apps/sdk-react";
import {useEffect, useState} from "react";
import {Navigate} from "react-router-dom";
import {FullScreenLoader} from "@/components/loader/FullScreenLoader.tsx";
import {getShortIdInfo, getSecretSantaShortIdInfo} from "@/api/apiMethods.ts";

export const ResolveStartParam = () => {
  const [ initRoute, setInitRoute ] = useState<string>("");
  const lp = useLaunchParams();
  const startParam = lp.initData?.startParam;

  const getInitRoute = async () => {
    if (!startParam) {
      return "/main";
    }

    if (startParam.substring(0, 5) === "tapps") {
      return "/main";
    }

    // checking legacy wishlist link
    if (startParam.substring(0, 1) !== '-') {
      return "/wishlists/"+startParam;
    }

    try {
      const b64RouteTry = atob(startParam.substring(1));
      if (b64RouteTry.indexOf("/items/") !== -1) {
        const wishlistId = b64RouteTry.split("/")[2];
        const wishId = b64RouteTry.split("/")[4];
        return "/wishlists/"+wishlistId+"/wishes/"+wishId;
      }
    } catch (e) { /* empty */ }

    const userPrefix = "-u";
    const wishlistPrefix = "-w";
    const allWishesPrefix = "-a";
    const wishPrefix = "-i";
    const santaPrefix = "-s";

    const routeType = startParam.substring(0, 2);
    const routeContent = startParam.substring(2);

    if (routeType === userPrefix) {
      if (routeContent.indexOf(wishPrefix) === -1) {
        return "/profiles/"+routeContent;
      }
      const itemId = routeContent.split(wishPrefix)[1];
      return "/profiles/"+routeContent+"/wishes/"+itemId;
    }

    if (routeType === wishlistPrefix) {
      let shortId = routeContent;
      let wishId = "";
      if (routeContent.indexOf(wishPrefix) !== -1) {
        const parts = routeContent.split(wishPrefix);
        shortId = parts[0];
        wishId = parts[1];
      }

      try {
        const { wishlistId, isOwner } = await getShortIdInfo(+shortId);
        let prefix = "";
        if (isOwner) {
          prefix = "/main";
        }
        if (wishlistId) {
          return `${prefix}/wishlists/`+wishlistId+(wishId ? "/wishes/"+wishId : "");
        }
      } catch {
        return "/wishlists/"+shortId+(wishId ? "/wishes/"+wishId : "");
      }

      return "/wishlists/"+shortId+(wishId ? "/wishes/"+wishId : "");
    }

    if (routeType === santaPrefix) {
      const openSantaTab = routeContent.endsWith('_santa');
      const gameReference = openSantaTab ? routeContent.slice(0, -'_santa'.length) : routeContent;
      const { gameId } = await getSecretSantaShortIdInfo(gameReference);
      return `/main/secret-santa/${gameId}${openSantaTab ? '?tab=santa' : ''}`;
    }

    if (routeType === allWishesPrefix) {
      let wishId = "";
      if (routeContent.indexOf(wishPrefix) !== -1) {
        const parts = routeContent.split(wishPrefix);
        wishId = parts[1];
      }
      const route = "/main/wishes/all" + (wishId ? "/"+wishId : "");
      console.debug(route);
      return route;
    }

    return "/main";
  }

  useEffect(() => {
    getInitRoute().then(route => {
      setInitRoute(route);
    }).catch(() => {
      setInitRoute("/main");
    });
  }, [startParam]);

  if (!initRoute) {
    return <FullScreenLoader/>;
  }

  return <Navigate to={initRoute} replace={true} />;
}
